import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
interface ToastProps {
  message: string | null;
  onDismiss: () => void;
}
export function Toast({
  message,
  onDismiss
}: ToastProps) {
  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(onDismiss, 4000);
    return () => window.clearTimeout(timer);
  }, [message, onDismiss]);
  return <div role="status" aria-live="polite" className="pointer-events-none fixed inset-x-0 bottom-4 z-[60] flex justify-center px-4" data-id="element-91" data-mp="2lqk2l5fjcn8t">
      <AnimatePresence data-id="element-92" data-mp="2ur8g7z10oll6">
        {message ? <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.18
      }} className="pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-xl bg-navy-900 px-4 py-3 text-sm text-white shadow-raised" data-id="element-93" data-mp="2usb37vv7y3vt">
            <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-teal-300" aria-hidden="true" data-id="element-94" data-mp="3csjn9kac7mq8" />
            <p className="flex-1" data-id="element-95" data-mp="3hp0fapknql8l">{message}</p>
            <button type="button" onClick={onDismiss} aria-label="Dismiss notification" className="-mr-1 -mt-1 inline-flex h-8 w-8 items-center justify-center rounded-lg text-white/70 hover:bg-white/10 hover:text-white" data-id="element-96" data-mp="3lrx2ktl575iv">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="2y2ks7qe2wrez" />
            </button>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}